/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import managePatientModal from "../managePatientModal/managePatientModal.vue";
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import manageSoAModal from "../ManageSoAModal/ManageSoAModal.vue";
import VPagination from "@hennge/vue3-pagination";
import CreateSitePopUp from "../CreateSitePopUp/CreateSitePopUp.vue";
import EditStudyPopUp from "../EditStudyPopUp/EditStudyPopUp.vue";
import createnewversion from "../newversion/createnewversion.vue";
import retireFormPopUp from "../retireFormPopUp/retireFormPopUp.vue";
import importForms from "../importForms/importForms.vue";
import Forms_AI_PopUp from "../Forms_AI_PopUp/Forms_AI_PopUp.vue";
import Multiselect from "@vueform/multiselect";
import ImportSoAmodel from "./ImportSoAmodel.vue";
import uploaSoAprotocol from "./uploaSoAprotocol.vue";
import customModal from "../customModal/customModal.vue";

export default {
  name: "studyProfile",
  components: {
    VPagination,
    managePatientModal,
    manageVisitModal,
    manageSoAModal,
    CreateSitePopUp,
    EditStudyPopUp,
    createnewversion,
    retireFormPopUp,
    Multiselect,
    importForms,
    Forms_AI_PopUp,
    ImportSoAmodel,
    uploaSoAprotocol,
    customModal
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      uploadstudyprotocolpopup: false,
      importstudymodal: false,
      showSiteModal: false,
      showPatientModal: false,
      showFormsModal: false,
      token: store.getters.getIdToken,
      head: "",
      // pagination
      currentTemplatePage: 1,
      templatePageSize: 10,
      totalTemplatePages: 1,
      currentVisitPage: 1,
      visitPageSize: 10,
      totalVisitPages: 1,
      currentSitesPage: 1,
      sitesPageSize: 10,
      totalSitesPages: 1,
      currentSubjectPage: 1,
      subjectPageSize: 10,
      totalSubjectPages: 1,
      currentRecentFormsPage: 1,
      currentRecentFormsSize: 10,
      totalRecentFormsPage: 1,
      currentVisitiPages: 1,
      showSidePopup: [false],
      showVisitPopup: [false],
      showSoaPopup: [false],
      studyDetails: "",
      studyTemplates: [],
      defaultdate: "",
      visitList: [],
      returnList: [],
      patientLists: [],
      studyId: "",
      visitId: "",
      siteModal: false,
      showAssignTemplate: false,
      studyEditModal: false,
      newtemplate: "",
      creatversionpopup: false,
      newversionformid: "",
      templatelist: [],
      permissiontemplatlist: [],
      selectedTemplateIds: [],
      selectedvisitid: "",
      sourceId: "",
      sourceVersion: "",
      retireFormModal: false,
      rollsprivilages: "",
      AIpopup: false,
      formItems: [],
      templates: [],
      values: {
        modelName: "StudyDIsName",
        description: "",
        threshold: 0.7
      },
      showLoadingAnimation: false,
      clicked: false,
      showVisitForms: false,
      formsArray: [],
      SoAList: [],
      activityType: "",
      selectedStudy: "",
      showSoAModal: false,
      loadingECRFtemplates: false,
      loadingVisitList: false,
      loadingSiteList: false,
      showPatientLoading: false,
      soAId: "",
      addPrivilegeModal: false,
      addPrivilegebutton: true,
      showRecentFormsLoading: false,
      roleList: [],
      formlists: [],
      selectedTemplateId: [],
      selectedRoleList: [],
      rolesAndPrivilegelist: {},
      temprolesAndPrivilegelist: {},
      selectedPrivilegeList: [],
      privilegeList: [
        { value: "Add", label: "Add" },
        { value: "View", label: "View" },
        { value: "Edit", label: "Edit" }
      ],
      notifications: [],
      steps: [
        { value: 1, label: "Study Setup" },
        { value: 2, label: "Generate Site" },
        { value: 3, label: "Generate Subject" },
        { value: 4, label: "Generate eCRF Data" },
        { value: 5, label: "Configure and Execute Alerts Library" },
        { value: 6, label: "Configure and Run Data Signal Framework" },
        { value: 7, label: "Configure and Run RBQM Risk Calculation" },
        { value: 8, label: "Configure SDTM/ADaM Mapping Files" },
        { value: 9, label: "Generate SDTM/ADaM Datasets" },
        { value: 10, label: "Import SDTM/ADaM to Stats & Analysis" },
        { value: 11, label: "Generate TOC & Run Program" }
      ],
      currentStep: 0,
      showNotifPopup: false,
      studyImported: false,
      setSiteImport: false,
      setSubjectImport: false,
      setSyntheticData: false,
      setSyntheticDataImport: false,
      loadingSiteImport: false,
      loadingSubjectImport: false,
      loadingSyntheticData: false,
      loadingAlertLibrary: false,
      loadingRBQMFramework: false,
      loadingRBQMAlgorithm: false,
      loadingSDTMADaMMapping: false,
      loadingGenerateSDTMADaMMapping: false,
      loadingImportSTATProgress: false,
      loadingGenerateTOCAndRunProgram: false,
      failedStep: null,
      showTemplateUploadModal: false,
      templateUploadFile: null,
      templateUploadLoading: false,
      templateUploadValidation: false
    };
  },
  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    this.token = store.getters.getIdToken;
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json"
      }
    };
    this.defaultdate = localStorage.getItem("dateformat");
    this.rollsprivilages = await store.getters.getRolesprivilegeData;
    window.addEventListener("studyIdChanged", async () => {
      this.studyId = store.getters.getStudyIs;
      await this.getStudyDetails();
    });
    this.studyId = store.getters.getStudyIs;
    if (this.studyId == null || this.studyId == "") {
      alert(this.$t("navigations.no study selected"));
    }
    document.addEventListener("click", this.onDocumentClick);
  },
  async beforeUnmount() {
    document.removeEventListener("click", this.onDocumentClick);
  },
  computed: {
    privilegeRows() {
      return this.selectedRoleList.flatMap(roleId =>
        this.selectedTemplateIds.map(templateId => {
          const tmpl = this.templates.find(t => t.templateId === templateId) || {};
          return {
            roleId,
            templateId,
            roleName: this.fetchRoleName(roleId),
            templateName: tmpl.templateName
          };
        })
      );
    },
    selectedmodeltemplate() {
      return this.selectedTemplateIds.map(id => {
        return this.templatelist.find(template => template.templateId === id);
      });
    }
  },
  methods: {
    openTemplateUploadModal() {
      this.templateUploadValidation = false;
      this.templateUploadFile = null;
      if (this.$refs.templateFileInput) {
        this.$refs.templateFileInput.value = "";
      }
      this.showTemplateUploadModal = true;
    },
    closeTemplateUploadModal(force = false) {
      if (this.templateUploadLoading && !force) return;
      this.templateUploadValidation = false;
      this.templateUploadFile = null;
      if (this.$refs.templateFileInput) this.$refs.templateFileInput.value = "";
      this.showTemplateUploadModal = false;
    },
    browseTemplateFile() {
      if (this.$refs.templateFileInput) this.$refs.templateFileInput.click();
    },
    onTemplateFileChange(event) {
      const file = event?.target?.files?.[0];
      if (file && /\.(xls|xlsx)$/i.test(file.name)) {
        this.templateUploadFile = file;
        this.templateUploadValidation = false;
        return;
      }
      this.templateUploadFile = null;
      this.templateUploadValidation = true;
    },
    async uploadStudyTemplate() {
      if (!this.templateUploadFile) {
        this.templateUploadValidation = true;
        return;
      }
      this.templateUploadLoading = true;
      this.templateUploadValidation = false;
      const formData = new FormData();
      formData.append("file", this.templateUploadFile, this.templateUploadFile.name);
      try {
        await axios.post(
          `${this.baseurl}/forms/template/importtemplates?StudyId=${this.selectedStudy}`,
          formData,
          { headers: { Authorization: `Bearer ${this.token}`, "Content-Type": "multipart/form-data" } }
        );
        await this.getECRF(this.selectedStudy);
        this.closeTemplateUploadModal(true);
        alert("Template imported successfully");
      } catch (err) {
        console.log("error in import template", err?.response?.data || err);
        const errMsg = err?.response?.data?.detail || err?.response?.data?.title || "Template import failed";
        alert(errMsg);
      } finally {
        this.templateUploadLoading = false;
      }
    },
    markStepFailed(stepValue) {
      if (this.failedStep) return;
      this.failedStep = stepValue;
      this.currentStep = stepValue;
      this.loadingSiteImport = false;
      this.loadingSubjectImport = false;
      this.loadingSyntheticData = false;
      this.loadingAlertLibrary = false;
      this.loadingRBQMFramework = false;
      this.loadingRBQMAlgorithm = false;
      this.loadingSDTMADaMMapping = false;
      this.loadingGenerateSDTMADaMMapping = false;
      this.loadingImportSTATProgress = false;
      this.loadingGenerateTOCAndRunProgram = false;
      const stepLabel = this.steps.find(step => step.value === stepValue)?.label || `Step ${stepValue}`;
      alert(`${stepLabel.toLowerCase()} failed`);
    },
    resetImportWorkflow() {
      this.currentStep = 0;
      this.failedStep = null;
      this.loadingSiteImport = false;
      this.loadingSubjectImport = false;
      this.loadingSyntheticData = false;
      this.loadingAlertLibrary = false;
      this.loadingRBQMFramework = false;
      this.loadingRBQMAlgorithm = false;
      this.loadingSDTMADaMMapping = false;
      this.loadingGenerateSDTMADaMMapping = false;
      this.loadingImportSTATProgress = false;
      this.loadingGenerateTOCAndRunProgram = false;
    },
    routeBack(importType) {
      switch (importType) {
        case "fromSite":
          this.studyImported = false;
          this.setSiteImport = false;
          this.currentStep--;
          break;
        case "fromSubject":
          this.setSiteImport = true;
          this.setSubjectImport = false;
          this.currentStep--;
          break;
        case "fromSyntheticData":
          this.setSubjectImport = true;
          this.setSyntheticData = false;
          this.currentStep--;
          break;
        default:
          console.warn("Invalid import type:", importType);
          break;
      }
    },
    async setStudy(value) {
      if (value) {
        this.resetImportWorkflow();
        this.studyImported = true;
        this.initialStudyLoader = true;
        this.selectedStudy = value;
        this.setSiteImport = true;
        this.currentStep++;
        await this.getECRF(value);
        await this.getVisits(value);
        await this.getSites(value);
        await this.getSubjects(value);
        await this.getRecentForms(value);
        await this.importSite();
        this.initialStudyLoader = false;
      }
    },
    async importSite() {
      this.currentStep = 2;
      this.loadingSiteImport = true;
      axios
        .post(`${this.baseurl}/management/study/syntheticsite?StudyId=${this.selectedStudy}`, {}, this.head)
        .then(res => {
          this.loadingSiteImport = false;
          if (res.data == "Sites Created") {
            this.importSubject();
            this.getSites(store.getters.getStudyIs);
          }
        })
        .catch(err => {
          console.log("error in get study", err);
          this.markStepFailed(2);
        });
    },
    async importSubject() {
      this.currentStep = 3;
      this.loadingSubjectImport = true;
      axios
        .post(`${this.baseurl}/management/study/syntheticsubjects?StudyId=${this.selectedStudy}`, {}, this.head)
        .then(res => {
          this.loadingSubjectImport = false;
          if (res.data == "Subjects Created") {
            this.importSyntheticData();
            this.getSubjects(store.getters.getStudyIs);
          }
        })
        .catch(err => {
          console.log("error in get study", err);
          this.markStepFailed(3);
        });
    },
    async importSyntheticData() {
      this.currentStep = 4;
      this.loadingSyntheticData = true;
      axios
        .post(`${this.baseurl}/management/study/syntheticforms?StudyId=${this.selectedStudy}`, {}, this.head)
        .then(res => {
          this.loadingSyntheticData = false;
          this.getRecentForms(store.getters.getStudyIs);
          this.importAlertLibrary();
        })
        .catch(err => {
          console.log("error in get study", err.response.data);
          this.markStepFailed(4);
        });
    },
    async importAlertLibrary() {
      this.loadingAlertLibrary = true;
      this.currentStep++;
      axios
        .post(`${this.baseurl}/forms/alert/syntheticalerts`, { studyId: this.selectedStudy }, this.head)
        .then(() => {
          this.loadingAlertLibrary = false;
          this.configureRBQMFramework();
        })
        .catch(err => {
          console.log("error in import alert library", err?.response?.data || err);
          this.markStepFailed(5);
          this.configureRBQMFramework();
        });
    },
    async configureRBQMFramework() {
      this.loadingRBQMFramework = true;
      this.currentStep++;
      axios
        .post(`${this.baseurl}/stats-python/formstatistics/automatedatasignal?studyId=${this.selectedStudy}`, {}, this.head)
        .then(() => {
          this.loadingRBQMFramework = false;
          this.runRBQMDataSignalAlgorithm();
        })
        .catch(err => {
          console.log("error in configure RBQM/data signal framework", err?.response?.data || err);
          this.markStepFailed(6);
          this.runRBQMDataSignalAlgorithm();
        });
    },
    async runRBQMDataSignalAlgorithm() {
      this.loadingRBQMAlgorithm = true;
      this.currentStep++;
      const now = new Date().toISOString();
      const payload = {
        createdUserEmail: store.getters.getUserEmail,
        createdUserId: store.getters.getUserId,
        createdAt: now,
        lastModifiedUserEmail: store.getters.getUserEmail,
        lastModifiedUserId: store.getters.getUserId,
        lastModifiedAt: now,
        studyId: this.selectedStudy
      };
      axios
        .post(`${this.baseurl}/forms/rbqm/automaterbqm`, payload, this.head)
        .then(() => {
          this.loadingRBQMAlgorithm = false;
          this.configureSDTMADaMMappingFiles();
        })
        .catch(err => {
          console.log("error in run RBQM data signal algorithm", err?.response?.data || err);
          this.markStepFailed(7);
          this.configureSDTMADaMMappingFiles();
        });
    },
    async configureSDTMADaMMappingFiles() {
      this.loadingSDTMADaMMapping = true;
      this.currentStep++;
      const sdtmPayload = { studyId: this.selectedStudy, domains: [], mapperIds: [] };
      axios
        .post(`${this.baseurl}/management/study/importsdtmmapertostudy`, sdtmPayload, this.head)
        .then(() => axios.post(`${this.baseurl}/management/study/importadammapertostudy`, { studyId: this.selectedStudy }, this.head))
        .then(() => {
          this.loadingSDTMADaMMapping = false;
          this.generateSDTMADaMMappingFiles();
        })
        .catch(err => {
          console.log("error in configure SDTM/ADaM mapping files", err?.response?.data || err);
          this.markStepFailed(8);
        });
    },
    async generateSDTMADaMMappingFiles() {
      this.loadingGenerateSDTMADaMMapping = true;
      this.currentStep++;
      const now = new Date().toISOString();
      const payload = {
        createdUserEmail: store.getters.getUserEmail || "",
        createdUserId: store.getters.getUserId || "",
        createdAt: now,
        lastModifiedUserEmail: store.getters.getUserEmail || "",
        lastModifiedUserId: store.getters.getUserId || "",
        lastModifiedAt: now,
        fileName: "",
        studyId: this.selectedStudy,
        domain: "",
        standardType: "",
        version: "",
        subjectId: "",
        templateId: "",
        interimVersion: "V1",
        dateCutoff: now,
        comments: ""
      };
      axios
        .post(`${this.baseurl}/forms/cdisc/maprawtosdtm`, payload, this.head)
        .then(() => axios.get(`${this.baseurl}/forms/cdisc/listauditsdtm?StudyId=${this.selectedStudy}`, this.head))
        .then(res => {
          const firstEntity = res?.data?.entities?.[0];
          if (!firstEntity) throw new Error("No SDTM audit entity found");
          const studyRef = firstEntity.studyRef || "";
          const auditId = firstEntity.id || "";
          const sdtmFolder = firstEntity.sdtmFilePath || "";
          const sdtmFileNames = Array.isArray(firstEntity.sdtM_FileNames) ? firstEntity.sdtM_FileNames : [];
          return axios.post(
            `${this.baseurl}/forms-ml/sdtmtoadam/processsdtmfiles/?study_id=${this.selectedStudy}&StudyRef=${encodeURIComponent(studyRef)}&AuditId=${encodeURIComponent(auditId)}&sdtmfolder=${encodeURIComponent(sdtmFolder)}`,
            sdtmFileNames,
            this.head
          );
        })
        .then(() => {
          this.loadingGenerateSDTMADaMMapping = false;
          this.importSTATProgress();
        })
        .catch(err => {
          console.log("error in generate SDTM/ADaM Datasets", err?.response?.data || err);
          this.markStepFailed(9);
        });
    },
    async importSTATProgress() {
      this.loadingImportSTATProgress = true;
      this.currentStep++;
      axios
        .get(`${this.baseurl}/forms/cdisc/listauditsdtm?StudyId=${this.selectedStudy}`, this.head)
        .then(res => {
          const firstEntity = res?.data?.entities?.[0];
          if (!firstEntity) throw new Error("No SDTM audit entity found");
          const payload = {
            createdUserEmail: firstEntity.CreatedUserEmail || "",
            createdUserId: firstEntity.CreatedUserId || "",
            createdAt: firstEntity.CreatedAt || new Date().toISOString(),
            lastModifiedUserEmail: firstEntity.LastModifiedUserEmail || "",
            lastModifiedUserId: firstEntity.LastModifiedUserId || "",
            lastModifiedAt: firstEntity.LastModifiedAt || new Date().toISOString(),
            auditId: firstEntity.id || "",
            fileNames: Array.isArray(firstEntity.adaM_FIleName) ? firstEntity.adaM_FIleName : [""],
            fileType: firstEntity.fileType || "ADAM",
            studyId: this.selectedStudy,
            studyRef: firstEntity.studyRef || "",
            interimVersion: firstEntity.interimVersion || "",
            filePath: firstEntity.adam_FilePath || "",
            active: true,
            domain: Array.isArray(firstEntity.aDaMFileType) ? firstEntity.aDaMFileType : [firstEntity.aDaMFileType || ""]
          };
          const sdtmpayload = {
            createdUserEmail: firstEntity.CreatedUserEmail || "",
            createdUserId: firstEntity.CreatedUserId || "",
            createdAt: firstEntity.CreatedAt || new Date().toISOString(),
            lastModifiedUserEmail: firstEntity.LastModifiedUserEmail || "",
            lastModifiedUserId: firstEntity.LastModifiedUserId || "",
            lastModifiedAt: firstEntity.LastModifiedAt || new Date().toISOString(),
            auditId: firstEntity.id || "",
            fileNames: Array.isArray(firstEntity.sdtM_FileNames) ? firstEntity.sdtM_FileNames : [""],
            fileType: firstEntity.fileType || "",
            studyId: this.selectedStudy,
            studyRef: firstEntity.studyRef || "",
            interimVersion: firstEntity.interimVersion || "",
            filePath: firstEntity.sdtmFilePath ? `/${firstEntity.sdtmFilePath}/CSV` : "",
            active: true,
            domain: Array.isArray(firstEntity.sdtM_FileNames) ? firstEntity.sdtM_FileNames.map(fileName => (typeof fileName === "string" ? fileName.replace(/\.[^/.]+$/, "") : "")) : [""]
          };
          return axios
            .post(`${this.baseurl}/forms/cdisc/dataimportforanalysis`, payload, this.head)
            .then(() => axios.post(`${this.baseurl}/forms/cdisc/dataimportforanalysis`, sdtmpayload, this.head));
        })
        .then(() => {
          this.loadingImportSTATProgress = false;
          this.generateTOCAndRunProgram();
        })
        .catch(err => {
          console.log("error in import STAT progress", err?.response?.data || err);
          this.markStepFailed(10);
        });
    },
    async generateTOCAndRunProgram() {
      this.loadingGenerateTOCAndRunProgram = true;
      this.currentStep++;
      axios
        .get(`${this.baseurl}/management/study/getbyid?id=${this.selectedStudy}`, this.head)
        .then(res => {
          const studyData = res?.data || {};
          return axios.post(`${this.baseurl}/stats-python/toc/createtocfromprotocol/${this.selectedStudy}`, { studyName: studyData.studyName || "", studyRef: studyData.studyRef || "" }, this.head);
        })
        .then(() => {
          this.loadingGenerateTOCAndRunProgram = false;
          this.currentStep = this.steps.length + 1;
        })
        .catch(err => {
          console.log("error in generate TOC & run program", err?.response?.data || err);
          this.markStepFailed(11);
        });
    },
    async getECRF(value) {
      this.loadingECRFtemplates = true;
      axios
        .get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${value}&pageindex=${this.currentTemplatePage}&pagesize=${this.templatePageSize}&SortProperty=templateName&SortOrder=0`, this.head)
        .then(res => {
          this.loadingECRFtemplates = false;
          this.studyTemplates = res.data.results;
          let totalCount = res.data.totalCount;
          this.totalTemplatePages = parseInt(totalCount / this.templatePageSize);
          if (totalCount % this.templatePageSize != 0) this.totalTemplatePages++;
        })
        .catch(err => {
          console.log("error in get study", err);
          this.initialStudyLoader = false;
          this.loadingECRFtemplates = false;
        });
    },
    async getVisits(value) {
      this.loadingVisitList = true;
      axios
        .get(`${this.baseurl}/management/visit/listvisit?StudyId=${value}&pageindex=${this.currentVisitiPages}&pagesize=${this.visitPageSize}&SortProperty=visitOrder`, this.head)
        .then(res => {
          this.loadingVisitList = false;
          this.visitList = res.data.results;
          let totalCount = res.data.totalCount;
          this.totalVisitPages = parseInt(totalCount / this.visitPageSize);
          if (totalCount % this.visitPageSize != 0) this.totalVisitPages++;
        })
        .catch(err => {
          this.loadingVisitList = false;
          console.log("error in list visit", err);
        });
    },
    async getSites(value) {
      this.loadingSiteList = true;
      await axios
        .get(`${this.baseurl}/management/site/searchlist?StudyID=${value}&pageindex=${this.currentSitesPage}&pagesize=${this.sitesPageSize}`, this.head)
        .then(res => {
          this.loadingSiteList = false;
          this.returnList = res.data.results;
          this.siteCode = this.returnList.siteCode;
          let totalCount = res.data.totalCount;
          this.totalSitesPages = parseInt(totalCount / this.sitesPageSize);
          if (totalCount % this.sitesPageSize != 0) this.totalSitesPages++;
        })
        .catch(err => {
          console.log(err);
          this.loadingSiteList = false;
        });
    },
    async getRecentForms(value) {
      this.showRecentFormsLoading = true;
      await axios
        .get(`${this.baseurl}/forms/forms/getpaginatedrecentforms?studyId=${value}&pageindex=${this.currentRecentFormsPage}&pagesize=${this.currentRecentFormsSize}`, this.head)
        .then(response => {
          this.showRecentFormsLoading = false;
          if (response.data) {
            this.formlists = response.data.results;
            let totalCount = response.data.totalCount;
            this.totalRecentFormsPage = parseInt(totalCount / this.currentRecentFormsSize);
            if (totalCount % this.currentRecentFormsSize != 0) this.totalRecentFormsPage++;
          } else {
            console.log("no forms found");
          }
        })
        .catch(err => {
          console.log(err);
          this.showRecentFormsLoading = false;
        });
    },
    async getSubjects(value) {
      this.showPatientLoading = true;
      await axios
        .get(`${this.baseurl}/management/patient/listpatient?Studyid=${value}&pageindex=${this.currentSubjectPage}&pagesize=${this.subjectPageSize}`, this.head)
        .then(res => {
          this.patientLists = res.data.results;
          this.totalSubjectPages = parseInt(res.data.totalCount / this.subjectPageSize);
          let totalCount = res.data.totalCount;
          if (totalCount % this.subjectPageSize != 0) this.totalSubjectPages++;
          this.showPatientLoading = false;
        })
        .catch(err => {
          console.error("No data found");
          this.showPatientLoading = false;
        });
    },
    loadTemplate(page) {
      this.currentTemplatePage = page;
      this.getECRF(this.selectedStudy);
    },
    loadVisit(page) {
      this.currentVisitiPages = page;
      this.getVisits(this.selectedStudy);
    },
    loadSites(page) {
      this.currentSitesPage = page;
      this.getSites(this.selectedStudy);
    },
    loadPatients(page) {
      this.currentSubjectPage = page;
      this.getSubjects(this.selectedStudy);
    },
    loadRecentPages(page) {
      this.currentRecentFormsPage = page;
      this.getRecentForms(this.selectedStudy);
    },
    filter(data) {
      if (data) return moment(data).format(this.defaultdate);
    },
    clearnotification() {
      this.notifications = [];
    },
    onDocumentClick(event) {
      if (!this.showNotifPopup) return;
      const popupEl = this.$refs.popup;
      const bellEl = this.$refs.bellIcon;
      if (!popupEl || !bellEl) {
        this.showNotifPopup = false;
        return;
      }
      if (!popupEl.contains(event.target) && !bellEl.contains(event.target)) {
        this.showNotifPopup = false;
      }
    },
    toggleNotificationPopup() {
      this.showNotifPopup = !this.showNotifPopup;
    },
    formatNotification(payload) {
      if (payload.message) {
        return payload.message + (payload.priority ? ` (priority: ${payload.priority})` : "");
      }
      return JSON.stringify(payload);
    },
    closeprotocolpopup() {
      this.uploadstudyprotocolpopup = false;
    },
    openUploadModal() {
      this.uploadstudyprotocolpopup = true;
    },
    closeimportstudy() {
      this.importstudymodal = false;
    },
    openimportstudymodal() {
      this.importstudymodal = true;
    },
    onRoleChange(newRoles) {
      this.selectedRoleList = newRoles;
      newRoles.forEach(rid => {
        if (!this.rolesAndPrivilegelist[rid]) this.rolesAndPrivilegelist[rid] = {};
        this.selectedTemplateIds.forEach(tid => {
          if (!Array.isArray(this.rolesAndPrivilegelist[rid][tid])) this.rolesAndPrivilegelist[rid][tid] = [];
        });
      });
    },
    onTemplateChange(newTemps) {
      this.selectedTemplateIds = newTemps;
      newTemps.forEach(tid => {
        this.selectedRoleList.forEach(rid => {
          const roleMap = this.rolesAndPrivilegelist[rid] || (this.rolesAndPrivilegelist[rid] = {});
          if (!Array.isArray(roleMap[tid])) roleMap[tid] = [];
        });
      });
    },
    fetchRoleName(roleID) {
      const role = this.roleList.find(r => r.roleID === roleID);
      return role ? role.roleName : "";
    },
    filterDate(date) {
      if (date) return moment(date).format(this.defaultdate);
    },
    async privilegeform() {
      this.selectedRoleList = [];
      this.selectedTemplateIds = [];
      this.rolesAndPrivilegelist = {};
      await this.getRoleList();
      await this.getFormPrivilege();
      this.addPrivilegeModal = true;
    },
    closePrivilege() {
      this.addPrivilegeModal = false;
      this.selectedRoleList = [];
      this.selectedTemplateIds = [];
      this.rolesAndPrivilegelist = {};
    },
    openretireModal(id, versionNo) {
      this.retireFormModal = true;
      this.sourceId = id;
      this.sourceVersion = versionNo;
    },
    async getStudyDetails() {
      axios
        .get(`${this.baseurl}/management/study/getbyid?id=${this.studyId}`, this.head)
        .then(res => (this.studyDetails = res.data))
        .catch(err => console.log("error in get study", err));
    },
    async getRoleList() {
      axios
        .get(`${this.baseurl}/account-core/roles/rolelist`, this.head)
        .then(res => {
          console.log("Role details ", res.data);
          this.roleList = res.data;
        })
        .catch(err => console.log("error in get study", err));
    },
    isAllSelected(col) {
      return this.privilegeRows.every(row => {
        const arr = this.rolesAndPrivilegelist[row.roleId][row.templateId] || [];
        return arr.includes(col);
      });
    },
    toggleColumn(col, event) {
      const checked = event.target.checked;
      this.privilegeRows.forEach(row => {
        const arr = this.rolesAndPrivilegelist[row.roleId][row.templateId];
        if (checked) {
          if (!arr.includes(col)) arr.push(col);
        } else {
          const idx = arr.indexOf(col);
          if (idx !== -1) arr.splice(idx, 1);
        }
      });
      this.rolesAndPrivilegelist = { ...this.rolesAndPrivilegelist };
    },
    async createFormPrivilege() {
      if (this.selectedRoleList.length === 0) {
        alert(this.$t("navigations.please select role and privilege"));
        return;
      }
      if (this.selectedTemplateIds.length === 0) {
        alert(this.$t("navigations.no template selected"));
        return;
      }
      const payload = this.formatPrivileges(this.rolesAndPrivilegelist, this.selectedTemplateIds);
      try {
        const res = await axios.post(`${this.baseurl}/forms/formsprivilege/createprivilege`, payload, this.head);
        console.log("Privilege created", res.data);
        alert(this.$t("navigations.privilege created successfully"));
      } catch (err) {
        console.error("error in creating privilege", err);
        alert(this.$t("navigations.failed to create privilege"));
      }
    },
    formatPrivileges(rolesAndPrivilegelist, templateIds) {
      const rolePrivileges = Object.entries(rolesAndPrivilegelist).map(([roleId, templatesMap]) => {
        const permission = templateIds.map(templateId => {
          const tmpl = this.templates.find(t => t.templateId === templateId) || {};
          const privileges = Array.isArray(templatesMap[templateId]) ? templatesMap[templateId] : [];
          return { templateId, templateName: tmpl.templateName || "", privileges: privileges.slice() };
        });
        return { roleId, permission };
      });
      return { studyId: this.studyId, rolePrivileges };
    },
    async getFormPrivilege(roleId = null) {
      const token = store.getters.getIdToken;
      const params = { studyId: this.studyId };
      if (roleId != null) params.roleId = roleId;
      try {
        const { data } = await axios.get(`${this.baseurl}/forms/formsprivilege/getprivileges`, { headers: { Authorization: `Bearer ${token}` }, params });
        this.formPrivilegeItems = data;
        this.addPrivilegebutton = data.length === 0;
        const templates = [...new Set(data.map(i => i.templateId))];
        this.selectedTemplateIds = templates;
        const roles = [...new Set(data.map(i => i.roleId))];
        this.selectedRoleList = roles;
        const nested = {};
        roles.forEach(rid => {
          nested[rid] = {};
          templates.forEach(tid => {
            const match = data.find(i => i.roleId === rid && i.templateId === tid);
            nested[rid][tid] = match ? (match.privileges || []).slice() : [];
          });
        });
        this.rolesAndPrivilegelist = nested;
        this.temprolesAndPrivilegelist = nested;
      } catch (err) {
        console.error("Error fetching privileges:", err);
      }
    },
    async updateFormPrivilege() {
      if (this.selectedRoleList.length === 0) {
        alert(this.$t("navigations.please select role and privilege"));
        return;
      }
      if (this.selectedTemplateIds.length === 0) {
        alert(this.$t("navigations.no template selected"));
        return;
      }
      const payload = this.formatPrivileges(this.rolesAndPrivilegelist, this.selectedTemplateIds);
      try {
        await axios.put(`${this.baseurl}/forms/formsprivilege/update`, payload, this.head);
        alert(this.$t("navigations.privilege updated successfully"));
      } catch (err) {
        console.error("Error updating privileges", err);
        alert(this.$t("navigations.failed to update privilege"));
      }
    },
    async readdmissingprivileges() {
      Object.entries(this.temprolesAndPrivilegelist).forEach(([roleId, tmplMap]) => {
        if (!this.rolesAndPrivilegelist[roleId]) {
          this.rolesAndPrivilegelist[roleId] = { ...tmplMap };
        } else {
          Object.entries(tmplMap).forEach(([templateId, savedPrivs]) => {
            if (!Array.isArray(this.rolesAndPrivilegelist[roleId][templateId])) {
              this.rolesAndPrivilegelist[roleId][templateId] = savedPrivs.slice();
            }
          });
        }
      });
      console.log("this.temprolesAndPrivilegelist", this.temprolesAndPrivilegelist);
      console.log("this.rolesAndPrivilegelist", this.rolesAndPrivilegelist);
      console.log("this.selectedTemplateIds", this.selectedTemplateIds);
    },
    uniqueBy(arr, key) {
      const seen = new Set();
      return arr.filter(o => {
        if (seen.has(o[key])) return false;
        seen.add(o[key]);
        return true;
      });
    },
    async templateList() {
      axios
        .get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${this.studyId}&pagesize=100&SortProperty=templateName&SortOrder=0`, this.head)
        .then(res => {
          console.log("template details ", res.data.results);
          this.permissiontemplatlist = res.data.results;
          this.templates = this.uniqueBy(this.permissiontemplatlist, "sourceTemplateId");
        })
        .catch(err => console.log("error in get template list", err));
    },
    async getPagesByTemplateId(id, version) {
      await axios
        .get(`${this.baseurl}/forms/templatedesign/getpagesbyid?formId=${id}&version=${version}`, this.head)
        .then(res => {
          console.log("get pages...", res.data);
          this.newtemplate = res.data;
        })
        .catch(err => console.log("error in get pages", err));
    },
    async visitPopup(visitIdEdit) {
      this.showSiteModal = true;
      this.visitId = visitIdEdit;
    },
    async soAPopup(soAIdEdit) {
      console.log("entered", soAIdEdit);
      this.showSoAModal = true;
      this.soAId = soAIdEdit;
    },
    async deleteForms(id) {
      if (confirm(this.$t("navigations.are you sure you want to delete this form?"))) {
        await axios
          .delete(`${this.baseurl}/forms/templatedesign/deleteform?formId=${id}`, this.head)
          .then(res => {
            alert(this.$t("navigations.form deleted successfully"));
            this.getECRF();
            this.templateList();
          })
          .catch(err => {
            alert(this.$t("navigations.failed due to internal error"));
            console.error(err);
          });
      }
      this.showSidePopup = [false];
    },
    async deleteVist(id) {
      if (confirm(this.$t("navigations.are you sure you want to delete this visit?"))) {
        await axios
          .delete(`${this.baseurl}/management/visit/delete?id=${id}`, this.head)
          .then(res => {
            alert(this.$t("navigations.visit deleted successfully"));
            this.listVisit();
          })
          .catch(err => {
            alert(this.$t("navigations.failed due to internal error"));
            console.error(err);
          });
      }
      this.showVisitPopup = [false];
    },
    async viewtemplatefun(templateFormId, version) {
      store.dispatch("setViewtemplateid", templateFormId);
      store.dispatch("setViewformid", templateFormId);
      this.$router.push(`/viewform/${templateFormId}`);
    },
    async createNewVersion(templateFormId, version, sourceTemplateId, templateId) {
      console.log(" in create new version study profile", version);
      localStorage.setItem("isStudyProfileRoute", true);
      localStorage.setItem("templateFormId", templateFormId);
      localStorage.setItem("version", version);
      localStorage.setItem("sourceTemplateId", sourceTemplateId);
      localStorage.setItem("latestTempId", templateId);
      localStorage.setItem("DesignFormPrvRoute", "studyProfile");
      this.$router.push({ path: "/formdesigner", query: { templateId: templateId } });
    },
    async gettemplatedata() {
      await axios
        .get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${this.studyId}&SortProperty=templateName&SortOrder=0`, this.head)
        .then(res => {
          this.templatelist = (res.data.results || []).sort((a, b) => a.templateName.localeCompare(b.templateName));
          console.log("list template data is...", this.templatelist);
        })
        .catch(err => console.log("error in get template details ", err));
    },
    async assignTemplate() {
      if (this.selectedTemplateIds.length == 0) {
        alert(this.$t("navigations.please select a form"));
      } else {
        this.templateNameArray = [];
        console.log("Value is", this.selectedmodeltemplate);
        this.selectedmodeltemplate.forEach((item, index) => {
          this.formsArray[index] = { template_ID: "", templateName: "", version: "" };
          this.formsArray[index].template_ID = item.templateId;
          this.formsArray[index].templateName = item.templateName;
          this.formsArray[index].version = item.version;
        });
        await axios
          .put(`${this.baseurl}/management/visit/assigntemplate`, { visitID: this.selectedvisitid, forms: this.formsArray }, this.head)
          .then(res => {
            alert(this.$t("navigations.form assigned successfully"));
            console.log(res.data);
            this.formsArray = [];
            this.selectedmodeltemplate = [];
            this.listVisit();
          })
          .catch(err => console.log("error in assign template", err));
        this.closeTemplateModal();
      }
    },
    async createTemplate() {
      localStorage.setItem("isFormCreateTemplateRoute", true);
      this.$router.push(`/formdesigner`);
      localStorage.setItem("DesignFormPrvRoute", "studyProfile");
    },
    closecreatenewversion() {
      this.newversionformid = "";
      this.creatversionpopup = false;
    },
    async closeModal() {
      this.showSiteModal = false;
      await this.listVisit();
    },
    async closeRetireModal() {
      this.retireFormModal = false;
      await this.getECRF();
      await this.templateList();
      await this.listVisit();
    },
    async closeSoAModal() {
      await this.listSOAs();
      this.showSoAModal = false;
    },
    async openTemplateModal(visitid) {
      this.selectedvisitid = visitid;
      this.showAssignTemplate = true;
      await this.gettemplatedata();
      await this.getAllForms(visitid);
      if (this.formItems != null) {
        this.selectedTemplateIds = this.formItems.map(item => item.template_ID);
      }
    },
    async closeTemplateModal() {
      this.selectedTemplateIds = [];
      this.showAssignTemplate = false;
    },
    async openFormsModal(visitid, patientId) {
      console.log("from fill form list", patientId);
      localStorage.setItem("patID", patientId);
      this.selectedvisitid = visitid;
      await this.getAllForms(visitid);
      this.showVisitForms = true;
    },
    async closeModalForms() {
      this.showVisitForms = false;
    },
    async getAllForms(visitId) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/management/visit/getallforms?studyId=${this.studyId}&visitId=${visitId}`, {
          headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" }
        })
        .then(res => {
          this.formItems = res.data;
          console.log("visit form list is...", this.formItems);
        })
        .catch(err => console.log(err));
    },
    async onClickButton() {
      this.showLoadingAnimation = true;
      this.clicked = true;
      await this.getStudyDescription();
      this.showLoadingAnimation = false;
      this.clicked = false;
    },
    async getStudyDescription() {
      const studyId = store.getters.getStudyIs;
      try {
        const response = await axios.get(`${this.baseurl}/management/study/getbyid?id=${studyId}`, this.head);
        this.StudyDescription = response.data;
        console.log("StudyDescription", this.StudyDescription);
        await this.formGeneration();
        if (Array.isArray(this.StudyDescription.studyProperties)) {
          this.FromStudy = this.StudyDescription.studyProperties;
        } else {
          console.log("No arrays found in studyProperties");
          this.FromStudy = [];
        }
      } catch (error) {
        console.log("Error in getting study:", error);
      }
    },
    async formGeneration() {
      axios
        .get(`${this.baseurl}/forms-ml/mlmodel/getvalues?model_name=${this.values.modelName}&data=${this.StudyDescription}&threshold=${this.values.threshold}`)
        .then(res => {
          this.formList = res.data;
          console.log("Arrays extracted from studyProperties and stored in FromStudy:", this.FromStudy);
          console.log("Form list", res.data);
          this.$router.push({ path: "/FormSuggestions", query: { formList: encodeURIComponent(JSON.stringify(this.formList)) } });
        })
        .catch(err => console.log("error in get study", err));
      await store.dispatch("setformList", JSON.stringify(this.formList));
    },
    async viewForm(id) {
      this.$router.push(`/viewTemplate/studyProfile/${id}`);
    },
    async listSOAs() {
      await axios
        .get(`${this.baseurl}/management/study/listsoa?studyId=${this.studyId}&activityType=${this.activityType}&pageindex=${this.soaCurrentPage}&pagesize=${this.pageSize}`, this.head)
        .then(res => {
          console.log("SoA list", res.data);
          this.SoAList = res.data.entities;
          let totalCount = res.data.totalCount;
          this.soaTotalPages = parseInt(totalCount / this.pageSize);
          if (totalCount % this.pageSize != 0) this.soaTotalPages++;
        })
        .catch(err => console.log("error in listing SoA", err));
    },
    async deleteSoA(id, index) {
      if (confirm(this.$t("navigations.are you sure you want to delete this activity?"))) {
        await axios
          .delete(`${this.baseurl}/management/study/deletesoa?id=${id}`, this.head)
          .then(res => console.log(" SoA deleted", res.data))
          .catch(err => console.log("error deleting SoA"));
      }
      this.showSoaPopup[index] = false;
      this.listSOAs();
    }
  }
};